import { render } from "./leak-fix.vue?vue&type=template&id=664b41ba&scoped=true&ts=true"
import script from "./leak-fix.vue?vue&type=script&lang=ts"
export * from "./leak-fix.vue?vue&type=script&lang=ts"

import "./leak-fix.vue?vue&type=style&index=0&id=664b41ba&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664b41ba"]])

export default __exports__